import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { GestaoOnboardingDetailsService } from './gestao-onboarding-details.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { NbDialogService } from '@nebular/theme';
import { ModalVisualizarOnboardComponent } from './modal-visualizar-onboard/modal-visualizar-onboard.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-gestao-onboarding-details',
  templateUrl: './gestao-onboarding-details.component.html',
  styleUrls: ['./gestao-onboarding-details.component.scss']
})
export class GestaoOnboardingDetailsComponent implements OnInit {

  public formGestaoOnboarding = null;
  public erroLog = null;
  public rowData: any = [];
  public columnsTabe = null;
  public tableLimit = 12;
  public cpfCnpj = null;
  public descricao = null;
  public onboardId = null;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  public cadastro = null;
  public endereco = null;
  public contato = null;
  public representanteLegal = null;
  public enriquecimento = null;
  public verificacao = null;
  public contaPagamento = null;
  public acesso = null;
  public stepCondition = false;
  public stepSelected = null;
  public viewObject = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: GestaoOnboardingDetailsService,
    private dialogService: NbDialogService,
    public router: Router,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,
    private spinnerService: NgxSpinnerService,

  ) {
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.onboardId = this.encriptyService.decriptyBySecretKey(params.get('id'));

    });

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.buscar(this.onboardId);
  }

  buscar(data: any) {

    this.spinnerService.show();
    this.service.buscaOnboardById(data, (response => {
      this.viewObject = response;
      this.cadastro = this.extractStyle(response.cadastro);
      this.endereco = this.extractStyle(response.endereco);
      this.contato = this.extractStyle(response.contato);
      this.representanteLegal = this.extractStyle(response.representanteLegal);
      this.enriquecimento = this.extractStyle(response.enriquecimento);
      this.verificacao = this.extractStyle(response.verificacao);
      this.contaPagamento = this.extractStyle(response.contaPagamento);
      this.acesso = this.extractStyle(response.acesso);
      this.cpfCnpj = DocumentoHelper.formatarDocumento(response.cpfCnpj);
      this.descricao = response.descricao;
      if (this.cadastro != null) {
        this.stepCondition = true;
      }

      this.spinnerService.hide();
    }), (erro) => {
      this.spinnerService.hide();
      this.notificationService.warn(erro.message);
    });

  }

  reprocessar() {

    let dataEtapa = null;
    if (this.viewObject.cadastro === 'FALHA') {
      dataEtapa = 'CADASTRO';
    } else if (this.viewObject.endereco === 'FALHA') {
      dataEtapa = 'ENDERECO';
    } else if (this.viewObject.contato === 'FALHA') {
      dataEtapa = 'CONTATO';
    } else if (this.viewObject.representanteLegal === 'FALHA') {
      dataEtapa = 'REPRESENTANTE_LEGAL';
    } else if (this.viewObject.enriquecimento === 'FALHA') {
      dataEtapa = 'ENRIQUECIMENTO';
    } else if (this.viewObject.verificacao === 'FALHA') {
      dataEtapa = 'VERIFICACAO';
    } else if (this.viewObject.contaPagamento === 'FALHA') {
      dataEtapa = 'CONTA_PAGAMENTO';
    } else if (this.viewObject.acesso === 'FALHA') {
      dataEtapa = 'ACESSO';
    }

    this.spinnerService.show();
    this.service.reprocess(this.onboardId, dataEtapa, null, (response => {

      this.cadastro = this.extractStyle(response.cadastro);
      this.endereco = this.extractStyle(response.endereco);
      this.contato = this.extractStyle(response.contato);
      this.representanteLegal = this.extractStyle(response.representanteLegal);
      this.enriquecimento = this.extractStyle(response.enriquecimento);
      this.verificacao = this.extractStyle(response.verificacao);
      this.contaPagamento = this.extractStyle(response.contaPagamento);
      this.acesso = this.extractStyle(response.acesso);
      this.cpfCnpj = response.cpfCnpj;
      this.descricao = response.descricao;
      if (this.cadastro != null) {
        this.stepCondition = true;
      }

      this.spinnerService.hide();
    }), (erro) => {
      this.spinnerService.hide();
      this.notificationService.warn(erro.message);
    });

  }

  buscarLog(dataEtapa: any, page?: string) {
    this.stepSelected = dataEtapa;

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))
    params = params.append('sort', 'id,desc')

    if (page) {
      params = params.append('page', page)
    }

    this.spinnerService.show();
    this.service.buscaOnboardLog(this.onboardId, dataEtapa, params, (response => {

      this.erroLog = response.content.length;
      this.paginationService.setInfo(response)

      this.spinnerService.hide();
      if (this.erroLog == 0) {
        this.notificationService.warn('Não há dados nesse período!');
      }

    }), (erro) => {
      this.spinnerService.hide();
      this.notificationService.warn(erro.message);
    });

  }

  extractStyle(data: any) {
    if (data == null || data === 'PENDENTE') {
      return 'step';
    } else if (data === 'FINALIZADO') {
      return 'step completed';
    } else {
      return 'step fail';
    }
  }

  verifyCreateStep(data: any) {
    if (data !== 'NAO_NECESSARIO') {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.formGestaoOnboarding = this.formBuilder.group({
      cnpjCpf: [null],
      descricao: [null]
    });

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cpfCnpj);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  previousPage() {
    this.router.navigate(['/pages/backoffice/gestao-onboarding']);
  }


  showCardModal(data: any) {

    this.dialogService.open(ModalVisualizarOnboardComponent, {
      context: {
        text: data,
      },
    });

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
